export const DEMO_SPEED_KMH = 35;
export const SHOW_ROUTE_LINE = false;
export const UPDATE_INTERVAL_MS = 40;
export const TIME_UPDATE_INTERVAL_MS = 3000;
